"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeEntryInputSchema = exports.timeEntrySchema = void 0;
const zod_1 = require("zod");
const common_js_1 = require("./common.js");
const organisation_js_1 = require("./organisation.js");
/** A stored daily booking; the mockup's five-day tuple is a grid view. */
exports.timeEntrySchema = zod_1.z
    .strictObject({
    id: common_js_1.idSchema,
    tenantId: organisation_js_1.tenantSchema.shape.id,
    employeeId: common_js_1.idSchema,
    date: common_js_1.dateSchema,
    workPackageId: common_js_1.idSchema.nullable(),
    category: common_js_1.textSchema.nullable(),
    hours: common_js_1.hoursSchema,
})
    .refine((entry) => (entry.workPackageId === null) !== (entry.category === null), {
    message: 'Exactly one of workPackageId or category is required',
});
exports.timeEntryInputSchema = zod_1.z
    .strictObject({
    date: common_js_1.dateSchema,
    workPackageId: common_js_1.idSchema.nullable(),
    category: common_js_1.textSchema.nullable(),
    hours: common_js_1.hoursSchema,
})
    .refine((entry) => (entry.workPackageId === null) !== (entry.category === null), {
    message: 'Exactly one of workPackageId or category is required',
});
//# sourceMappingURL=time.js.map